import React from 'react';
import Header from '../../compos/Header/Header';
import BasicSlider from '../../compos/BasicSlider/BasicSlider';
import Footer from '../../compos/Footer/Footer';
import './Home.css';
import { useUser } from '../../UserContext';
import FeatureSlider from '../../compos/FeatureSlider/FeatureSlider';
import { Founders, TeamMembers, AdvisoryTeam } from '../../compos/Teams/TeamMembers';
import { useNavigate } from 'react-router-dom';

const Home = () => {
	const { user } = useUser();
	const navigate = useNavigate();

	return (
		<div className='min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50'>
			{/* Header */}
			<Header />

			{/* Hero Section */}
			<div className='home-scroll-point relative'>
				<BasicSlider />
			</div>

			{/* Modern Features Section */}
			<div className='feature-scroll-point py-20 bg-white relative'>
				{/* Background Pattern */}
				<div className='absolute inset-0 bg-gradient-to-br from-blue-50/30 to-transparent'></div>
				<div className='relative z-10'>
					<FeatureSlider />
				</div>
			</div>

			{/* Modern Team Section */}
			<div className='team-scroll-point py-20 bg-gradient-to-br from-blue-50 to-white relative overflow-hidden'>
				{/* Background decorations */}
				<div className='absolute top-10 right-10 w-72 h-72 bg-blue-200/20 rounded-full blur-3xl'></div>
				<div className='absolute bottom-10 left-10 w-96 h-96 bg-purple-200/20 rounded-full blur-3xl'></div>

				<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10'>
					{/* Founders Section */}
					<div className='text-center mb-16 animate-fade-in'>
						<h2 className='text-4xl lg:text-5xl font-bold text-[#022c56] mb-4'>Founders</h2>
						<div className='w-24 h-1 bg-gradient-to-r from-[#022c56] to-blue-400 mx-auto mb-8 rounded-full'></div>
						<p className='text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed'>
							Visionary leaders driving innovation in location-aware reporting technology
						</p>
					</div>
					<div className='animate-slide-up'>
						<Founders />
					</div>

					{/* Team Members Section */}
					<div className='text-center mb-16 mt-24 animate-fade-in'>
						<h2 className='text-4xl lg:text-5xl font-bold text-[#022c56] mb-4'>Team</h2>
						<div className='w-24 h-1 bg-gradient-to-r from-[#022c56] to-green-400 mx-auto mb-8 rounded-full'></div>
						<p className='text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed'>
							Talented individuals committed to building authentic reporting solutions
						</p>
					</div>
					<div className='animate-slide-up'>
						<TeamMembers />
					</div>

					{/* Advisory Team Section */}
					<div className='text-center mb-16 mt-24 animate-fade-in'>
						<h2 className='text-4xl lg:text-5xl font-bold text-[#022c56] mb-4'>Advisors</h2>
						<div className='w-24 h-1 bg-gradient-to-r from-[#022c56] to-purple-400 mx-auto mb-8 rounded-full'></div>
						<p className='text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed'>
							Industry experts guiding our strategic vision and technological advancement
						</p>
					</div>
					<div className='animate-slide-up'>
						<AdvisoryTeam />
					</div>
				</div>
			</div>

			{/* Call to Action Section */}
			<section className='py-20 bg-gradient-to-r from-[#022c56] via-[#034068] to-[#045580] relative overflow-hidden'>
				{/* Background pattern */}
				<div className='absolute inset-0 bg-black/10'></div>
				<div className='absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/5 to-transparent'></div>

				<div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10'>
					<h2 className='text-4xl lg:text-5xl font-bold text-white mb-6'>Ready to Start Authentic Reporting?</h2>
					<p className='text-xl text-blue-200 mb-10 leading-relaxed'>
						Join our community of reporters and make your voice heard with location-aware, authentic news reporting that
						makes a difference.
					</p>
					<div className='flex flex-col sm:flex-row gap-4 justify-center'>
						<button
							onClick={() => navigate(user ? '/news' : '/login')}
							className='px-8 lg:w-64 custom-get-started bg-yellow-500 hover:bg-yellow-400 text-[#022c56] font-bold text-lg rounded-full transition-all duration-300 hover:scale-105 shadow-xl'
						>
							Start Reporting Now
						</button>
						<button
							onClick={() => navigate('/contact')}
							className='px-8 lg:w-64 custom-get-started bg-white text-[#022c56] font-semibold text-lg rounded-full transition-all duration-300 hover:scale-105 shadow-xl'
						>
							Contact Us
						</button>
					</div>
				</div>
			</section>

			<Footer />
		</div>
	);
};

export default Home;
